import * as React from 'react';
import { WBBox } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LottieAlert from '../../LottieAlert/LottieAlert';
import { ScanItemsTable } from './Scanning/Desktop/ScanItemsTable';
import { ScanItemsMobile } from './Scanning/Mobile/ScanItemsMobile';
import { Bill } from '../PayBillCreateForm';
import {
  hasDocumentAnalysisFailed,
  isBillLoading,
} from '../../../helpers/tasks';

interface Props {
  bills: Bill[];
  setBills: (bills: Bill[]) => void;
  isLoading: boolean;
  openedRow: number;
  setOpenedRow: (row: number) => void;
  onExit: () => void;
}

export const ReviewForm = ({
  bills,
  setBills,
  openedRow,
  setOpenedRow,
  isLoading,
  onExit,
}: Props) => {
  const { t } = useTranslation();

  const isScanning = bills.some((bill) => isBillLoading(bill.documentAnalysis));
  const hasFailed = bills.some((bill) =>
    hasDocumentAnalysisFailed(bill.documentAnalysis)
  );

  return (
    <Content>
      {(isScanning || hasFailed) && (
        <LottieAlert
          lottiePath="/lottie/document-scanning.lottie"
          loop={true}
          title={
            hasFailed
              ? t('scanningFailedTitle', { ns: 'taskbox' })
              : t('scanningInProgressTitle', { ns: 'taskbox' })
          }
          message={
            hasFailed
              ? t('scanningFailedMessage', { ns: 'taskbox' })
              : t('scanningInProgressMessage', { ns: 'taskbox' })
          }
          severity={hasFailed ? 'warning' : 'info'}
          isIn={true}
          secondaryBtnText="Exit view"
          onSecondaryClick={() => {
            onExit();
          }}
        />
      )}
      <WBBox sx={{ display: ['block', 'none'] }}>
        <ScanItemsMobile
          opened={openedRow}
          setOpened={setOpenedRow}
          bills={bills}
          setBills={setBills}
        />
      </WBBox>
      <WBBox sx={{ display: ['none', 'block'] }}>
        <ScanItemsTable
          opened={openedRow}
          setOpened={setOpenedRow}
          bills={bills}
          setBills={setBills}
        />
      </WBBox>
    </Content>
  );
};
const Content = styled(WBBox)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
}));
